import { BasketContents } from '../BasketContents';
import { DiscountCode } from '../DiscountCode';
import { Card, DiscountStack } from './CheckoutSummaryPanel.styles';
import type { CheckoutSummaryPanelProps } from './CheckoutSummaryPanel.types';

export function CheckoutSummaryPanel({
  items,
  totalPrice,
  view,
  onViewChange,
  guests,
  onRemoveItem,
  protectionFee,
  subtotal,
  specialOffersDiscount,
  promotionsDiscount,
  vouchersDiscount,
  deliveryCost,
  dueToday,
  dueLater,
  dueLaterNote,
  promoCode,
  voucherCode,
  locale,
  labels,
}: CheckoutSummaryPanelProps) {
  const discountSlot =
    promoCode || voucherCode ? (
      <DiscountStack>
        {promoCode && <DiscountCode {...promoCode} />}
        {voucherCode && <DiscountCode {...voucherCode} />}
      </DiscountStack>
    ) : undefined;

  return (
    <Card data-testid="checkout-summary-panel">
      <BasketContents
        items={items}
        totalPrice={totalPrice}
        view={view}
        onViewChange={onViewChange}
        guests={guests}
        onRemoveItem={onRemoveItem}
        showTitle={false}
        protectionFee={protectionFee}
        subtotal={subtotal}
        specialOffersDiscount={specialOffersDiscount}
        promotionsDiscount={promotionsDiscount}
        vouchersDiscount={vouchersDiscount}
        deliveryCost={deliveryCost}
        dueToday={dueToday}
        dueLater={dueLater}
        dueLaterNote={dueLaterNote}
        discountSlot={discountSlot}
        locale={locale}
        labels={labels}
      />
    </Card>
  );
}
